<template>
    <div class="Adresses">
        <p class="SubTitle">{{ langPage['compte-popup-adresse']['TXT_adresselivraison'] }}</p>
        <addCarte
            :msg="msg1"
            :carteTitle="carteTitle"
            :width="!isMobile?'4.16':'80'"
            buttonVal="Ajouter une nouvelle adresse"
            @submit="(data,num) =>submit(data,num,1)"
        ></addCarte>

        <p class="SubTitle pt4">{{ langPage['compte-popup-adresse']['TXT_adressefacturation'] }}</p>
        <addCarte
            :msg="msg2"
            :carteTitle="carteTitle"
            :width="!isMobile?'4.16':'80'"
            buttonVal="Ajouter une nouvelle adresse"
            @submit="(data,num) =>submit(data,num,0)"
        ></addCarte>
    </div>
</template>
<script>
import addCarte from "../../components/addCarte";
import {mapState, mapMutations} from "vuex";

export default {
    name: "Adresses",
    components: {
        addCarte
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            submitState: true,
            carteTitle: [
                {
                    title: "Nom du contact",
                    key: "NomContact",
                    rule: [{required: true, message: "miss ", trigger: "blur"}],
                },
                {
                    title: "Société",
                    key: "Societe",
                    rule: [{required: true, message: "miss Société", trigger: "blur"}],
                },
                {
                    title: "Adresse",
                    key: "adresse",
                    rule: [{required: true, message: "miss Adresse", trigger: "blur"}],
                },
                {
                    title: "Téléphone",
                    key: "telephone",
                    rule: [{required: true, message: "miss Téléphone", trigger: "blur"}],
                },
                {
                    title: "Mobile",
                    key: "mobile",
                    rule: [{required: true, message: "miss Mobile", trigger: "blur"}],
                },
                {
                    title: this.$store.state.langPage['compte-informations-popup-adresse']['TXT_codepostal'],
                    key: "codePostal",
                    rule: [{required: true, message: "need codePostal", trigger: "blur"}],
                },
                {
                    title: "",
                    key: "id_acheteur",
                    rule: [{required: false, message: "miss id_acheteur", trigger: "blur"}],
                },
                {
                    title: "",
                    key: "id_annuaire",
                    rule: [{required: false, message: "miss id_annuaire", trigger: "blur"}],
                },
                {
                    title: "",
                    key: "id_vendeur",
                    rule: [{required: false, message: "miss id_vendeur", trigger: "blur"}],
                },
                {
                    title: "",
                    key: "id_adresse",
                    rule: [{required: false, message: "miss id_adresse", trigger: "blur"}],
                },
                {
                    title: this.$store.state.langPage['v4-topmenu']['TXT_payname'],
                    key: "pay_name",
                },
            ],
            msg1: [],//收货地址
            msg2: []   //发票地址
        };
    },
    created() {
        this.init()
    },
    computed: {
        ...mapState({
            acheteurId: state => state.acheteurId
        }),
        langPage() {
            return this.$store.state['langPage']
        }
    },
    methods: {
        init() {
            let acheteurId = this.acheteurId || localStorage.getItem('id_acheteur')
            this.$api.info.getAddress(acheteurId).then(res => {
                if (res.length == 0) return
                for (var i = 0; i < res.length; i++) {
                    if (res[i].type == 0) this.msg2.push(res[i])
                    else this.msg1.push(res[i])
                }
                console.log(res)
            }).finally(() => {
                this.submitState = true
            })
        },
        //删除地址
        deleAddress(data) {
            this.$api.info.deleAddress(data).then(res => {
                this.addAddress(data)
            }).catch(err => {
            })
        },
        addAddress(data) {
            let obj = {
                NomContact: "",
                Societe: "",
                adresse: "",
                id_acheteur: '',
                mobile: "",
                telephone: "",
                type: "",
                id_pays: "",
                codePostal: '',
            }
            for (var key in obj) {
                obj[key] = data[key];
            }
            obj.id_acheteur = this.acheteurId || localStorage.getItem('id_acheteur')
            this.$api.info.addAddress(obj).then(res => {
                this.init()
                this.$router.go(0)
                // console.log(res)
            })
        },
        //提交的地址数据，num编辑或者新增 0 编辑 1新增  addressType 地址类型，1 收货地址或者0 发票地址
        submit(data, num, addressType) {
            if (!this.submitState) return
            this.submitState = false
            data.type = addressType;
            if (num == 0) {   //编辑  先删再添加
                this.deleAddress(data)
            } else {   //新增
                this.addAddress(data)
            }
        }
    }
};
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Moncompte/Adresses.less">
</style>
